module.exports = __webpack_public_path__ + "img/welcome.4ad29b96.png";